export const isTenantReadOnly = (tenant) => Boolean(
    tenant?.isReadOnly || tenant?.isDisabled || tenant?.isDeleted
);

export const getEffectiveUserPermissions = (permissions, tenant) => {
    if (!isTenantReadOnly(tenant)) return permissions;
    return permissions.map((permission) => ({
        ...permission,
        canCreate: false,
        canUpdate: false,
        canDelete: false,
    }));
};

export const getEffectiveAreaPermission = (permissions, tenant, area, aziendaId) => {
    const permission = permissions?.find((item) => item.area === area && item.aziendaId === aziendaId);
    if (!permission) {
        return { canRead: false, canCreate: false, canUpdate: false, canDelete: false };
    }
    return getEffectiveUserPermissions([permission], tenant)[0];
};

export const LicenseHelpers = () => {

    const checkHasSignatureCapability = (signatureConfig) => {
        return signatureConfig?.frq === true || signatureConfig?.fmq === true;
    }
    const checkHasArchiveLicense = (licenses, authTenantId) => {
        if (!licenses) return false;
        return licenses.some((license) =>
            license.agyoService?.appId === "ARC" &&
            license.availableToUser &&
            license.itemId === authTenantId
        );
    }

    return{
        checkHasSignatureCapability,
        checkHasArchiveLicense
    }
}